<template>
  <slot :handleSubmit="handleSubmitSlot" :invalid="invalid" :validate="validateSlot" :reset="resetSlot" />
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import { useForm } from 'vee-validate';

export default defineComponent({
  name: 'ValidationObserver',
  setup(_props, { expose }) {
    const { handleSubmit, validate, resetForm, meta } = useForm({
      validateOnMount: false
    });

    const invalid = computed(() => meta.value.valid === false);

    const handleSubmitSlot = async (cb: Function) => {
      return handleSubmit(async (values: any, ctx: any) => cb(values, ctx))();
    };

    const validateSlot = async (opts?: any) => {
      const res: any = await validate({ mode: 'force', ...(opts || {}) });
      return res?.valid ?? false;
    };

    const resetSlot = () => {
      resetForm();
    };

    expose({
      validate: validateSlot,
      reset: resetSlot
    });

    return { handleSubmitSlot, invalid, validateSlot, resetSlot };
  }
});
</script>
